export function formatDescriptionHtml(text) {
  if (!text) return '';
  // If content has list tags, pass through as-is (just clean up &nbsp;)
  if (/<(ul|ol)\b/i.test(text)) {
    return text.replace(/&nbsp;/g, ' ');
  }
  // If no HTML tags, convert plain text newlines to <br>
  if (!/<(p|h[1-6]|div|br|blockquote)\b/i.test(text)) {
    return text.replace(/\n/g, '<br>');
  }
  // Clean up broken contentEditable output where each word is a separate <p> tag
  const segments = text.split(/<\/p>\s*<p>/i);
  if (segments.length <= 1) return text;
  const stripHtml = (s) => s.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  const merged = [];
  let buffer = '';
  for (let i = 0; i < segments.length; i++) {
    const clean = stripHtml(segments[i]);
    if (clean === '') {
      if (buffer) { merged.push(buffer); buffer = ''; }
      merged.push('');
    } else if (clean.length < 40 && i > 0 && i < segments.length - 1) {
      buffer = buffer ? (buffer + ' ' + clean) : clean;
    } else {
      if (buffer) {
        if (clean.length < 80 && !clean.includes('. ')) {
          buffer = buffer + ' ' + clean;
        } else {
          merged.push(buffer);
          buffer = '';
          merged.push(clean);
        }
      } else {
        merged.push(clean);
      }
    }
  }
  if (buffer) merged.push(buffer);
  return merged.map(s => s ? `<p>${s}</p>` : '<br>').join('');
}

export const statusLabels = {
  '-1': { label: 'Canceled', color: 'bg-red-100 text-red-700' },
  '0': { label: 'To Book', color: 'bg-slate-200 text-slate-700' },
  '1': { label: 'Booked', color: 'bg-blue-100 text-blue-700' },
  '2': { label: 'On going', color: 'bg-yellow-100 text-yellow-700' },
  '3': { label: 'Completed', color: 'bg-green-100 text-green-700' },
};

export const statusBtnLabel = { 0: 'Book a schedule', 1: 'Set to On going', 2: 'Mark as completed' };
export const typeLabels = { 1: 'Item', 2: 'Services', 3: 'Labour', 4: 'MISC' };

// === BOOK SCHEDULE MODAL (for To Book status) ===
